import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login/Login'
import Index from '@/pages/Index/Index'
import Agreement from '@/pages/Agreement/agreement'
import Content from '@/pages/Agreement/agreeContent'
import knowCard from '@/pages/KnowCard/knowCard'
import knowlist from '@/pages/KnowCard/knowlist'
import Face from  '@/pages/face/face'
import FaceEnd from '@/pages/face/faceEnd'
import Name from  '@/pages/face/name'
import clamInfo from  '@/pages/face/clamInfo'
import knowCardDetail from "../pages/KnowCard/knowCardDetail.vue";
import NameEnd from '@/pages/face/nameEnd'
//农险概况
import OperationSummary from '@/pages/operationSummary/operationSummary'

import Clause from '@/pages/Clause/clause'
import Secret from '@/pages/Secret/secret'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    },

    {
      path: '/agreement/content',
      name: 'Content',
      component: Content
    },
    {
      path: '/operationSummary',
      name: 'OperationSummary',
      component: OperationSummary
    },
    {
      path: '/clause',
      name: 'Clause',
      component: Clause
    },
    {
      path: '/secret',
      name: 'Secret',
      component: Secret
    },
    {
      path: '/knowCard',
      name: 'KnowCard',
      component: knowCard
    },
    {
      path: '/knowlist',
      name: 'knowlist',
      component: knowlist
    },
    {
      path: '/knowCardDetail',
      name: 'knowCardDetail',
      component: knowCardDetail
    },
    {
      path: '/face/face',
      name: 'face',
      component: Face
    },

    {
      path: '/face/faceEnd',
      name: 'faceEnd',
      component: FaceEnd
    },
    {
      path: '/face/clamInfo',
      name: 'clamInfo',
      component: clamInfo
    },
    {
      path: '/face/name',
      name: 'name',
      component: Name
    },
    {
      path: '/face/nameEnd',
      name: 'nameEnd',
      component: NameEnd
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js